import { childErrorReduc, isRenteEducationRequired } from '@@viewHelpers/validations/guaranteesPrevTns.js';
import { filter, propEq, propOr } from 'ramda';
import { useMemo } from 'react';
import { getReimbursementGraphContent } from './helpers/getReimbursementGraphContent.js';

const useNiveauxGarantiesTarifsPrevTnsRenteEducationForm = ({
  form,
  guarantees,
  getMiddleText,
  annualIncome
}) => {
  const rEduc = form.watch('guarantees.OPTION_REDUC.selected');
  const reducCap = form.watch('guarantees.REDUC_CAP.value');

  const {
    OPTION_REDUC,
    REDUC_CAP,
    REDUC_MAD
  } = guarantees;

  // Calcul dynamique de la part assureur pour REDUC_CAP (3 tranches d'âge)

  const reducHealthInsurances = useMemo(() => {
    if (!rEduc || !reducCap) return [];

    // Les valeurs sont toujours séparées par '_' depuis le backend (ex: "10_15_20")
    const percentages = reducCap.split('_').map(v => parseFloat(v) || 0);

    return percentages.map(percentage => {
      const insurerAmount = annualIncome * (percentage / 100);
      return insurerAmount.toString();
    });
  }, [rEduc, reducCap, annualIncome]);

  const renteEducationCotisation = [
    {
      displayed: rEduc,
      label: getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_REDUC_LABEL'),
      monthlyAmount: propOr(0.0, 'monthlyPrice', REDUC_CAP),
      yearlyAmount: propOr(0.0, 'annualPrice', REDUC_CAP)
    }
  ];

  const reducReimbursementGraphContent = getReimbursementGraphContent(
    reducHealthInsurances,
    propOr([], 'labelsRO', REDUC_CAP),
    propOr([], 'RO', REDUC_CAP)
  );

  return {
    rEduc,
    isRenteEducationRequired,
    childErrorReduc,
    OPTION_REDUC,
    REDUC_MAD,
    renteEducationCotisation: filter(propEq('displayed', true), renteEducationCotisation),
    reducHealthInsurances,
    reducReimbursementGraphContent
  };
};

export default useNiveauxGarantiesTarifsPrevTnsRenteEducationForm;
